// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"b933ccb0","453":"f2ceef12","495":"ea8749b3","691":"2068a371","751":"725f3b44","767":"97706a21","773":"97d3c8f4","805":"5f524945"}[chunkId] + ".chunk.js";
};